import { ApiEntity } from 'app/api/models/api-entity.model';

export class TimeProviderDetailModel extends ApiEntity {
  constructor(public id: number = null, public Now: Date , public RealTime: Boolean, public FixedTime: Boolean,
    public BaseDate: Date, public IncrementDays: Number, public IncrementTime: Number) {
    super();
  }
}
